/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import * as Ui from './ColorPicker.styles';

const ColorButton = ({ color: { name, uid, hex_value: hexValue }, isSelected, onClick }) => (
  <Ui.Color
    color={hexValue}
    selected={isSelected}
    aria-label={`Color ${name}`}
    onClick={onClick ? () => onClick(uid) : undefined}
    type="button"
  />
);

const ScrollArrow = ({ direction, visible, onClick }) => (
  <Ui.Arrow visible={visible} direction={direction} onClick={onClick} aria-hidden={!visible} />
);

export const ColorPicker = ({ onClick, colors, selectedColors, skipSelect = false }) => {
  const childrenWrapper = useRef(null);
  const [movedFromLeft, setMovedFromLeft] = useState(0);

  const uniqueColors = _.uniqBy(colors, 'uid');

  const handleArrowClick = (direction) => {
    const moveAmount = direction === 'left' ? -30 : 30;
    setMovedFromLeft((prev) => prev + (direction === 'left' ? -1 : 1));
    childrenWrapper.current?.scrollTo({
      left: childrenWrapper.current.scrollLeft + moveAmount,
      behavior: 'smooth',
    });
  };

  const isRightArrowVisible = uniqueColors.length > 6 && movedFromLeft !== uniqueColors.length - 6;

  if (!selectedColors?.length) return null;

  return (
    <Ui.Wrapper>
      <Ui.ColorsWrapper>
        <ScrollArrow
          direction="left"
          visible={movedFromLeft !== 0}
          onClick={() => handleArrowClick('left')}
        />
        <div ref={childrenWrapper} style={{ display: 'flex', gap: '4px' }}>
          {uniqueColors.map((color) => (
            <ColorButton
              key={color.uid}
              color={color}
              isSelected={skipSelect ? false : selectedColors.includes(color.uid)}
              onClick={skipSelect ? undefined : onClick}
            />
          ))}
        </div>
        <ScrollArrow
          direction="right"
          visible={isRightArrowVisible}
          onClick={() => handleArrowClick('right')}
        />
      </Ui.ColorsWrapper>
    </Ui.Wrapper>
  );
};

ColorPicker.propTypes = {
  colors: PropTypes.arrayOf(
    PropTypes.shape({
      uid: PropTypes.string,
      name: PropTypes.string,
      hex_value: PropTypes.string,
    }),
  ).isRequired,
  selectedColors: PropTypes.arrayOf(PropTypes.string),
  skipSelect: PropTypes.bool,

  onClick: PropTypes.func,
};

ColorButton.propTypes = {
  color: PropTypes.shape({
    uid: PropTypes.string,
    name: PropTypes.string,
    hex_value: PropTypes.string,
  }).isRequired,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
};

ScrollArrow.propTypes = {
  direction: PropTypes.oneOf(['left', 'right']).isRequired,
  visible: PropTypes.bool,
  onClick: PropTypes.func,
};
